import * as React from 'react';
import { useState, useRef } from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';

const options = ['dia', 'semana', 'mes', 'variable', 'año', 'año-variable', 'ultimos-12meses'];

export default function ViewerSelector({onViewSelector, viewByDefault}) {
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(viewByDefault === 'variable' ? 3 : 7);
  const anchorRef = useRef(null);
 
  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
    onViewSelector(options[index]);
  };

  const handleToggle = () => { setOpen((prevOpen) => !prevOpen); };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if(viewByDefault === 'ultimos-7dias') {
      if(!options.find(op => op === 'ultimos-7dias')) {
        options.push('ultimos-7dias')
      }
    }
  }, [viewByDefault])
  
  return (
    <div>
      <ButtonGroup variant="outlined" ref={anchorRef} aria-label="visualizador">
        <Button onClick={handleClick}>{options[selectedIndex]}</Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="Selecciona visualización"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
         {!open ? <FontAwesomeIcon icon={faChevronDown} /> : <FontAwesomeIcon icon={faChevronUp} />}
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}